import type { User } from '@freelancer/datastore/collections';

export const INITIAL_PAGE_SIZE = 20;

export enum CallRecordType {
  INCOMING = 'incoming',
  OUTGOING = 'outgoing',
  MISSED = 'missed', // Only seen for receiver when they miss the call
  DECLINED = 'declined',
  CANCELLED = 'cancelled', // Only seen for caller when they cancel the call
  FAILED = 'call_failed',
}

export interface CallRecord {
  id: number;
  threadId: number;
  startTime: number;
  duration?: number;
  type: CallRecordType;
}

export interface CallLogUserEntry {
  user: User;
  callRecords: CallRecord;
}

export enum DateGroup {
  TODAY = 'today',
  YESTERDAY = 'yesterday',
  OLDER = 'older',
}

export interface GroupedCallLogEntries {
  dateGroup: DateGroup;
  entries: readonly CallLogUserEntry[];
}

export enum Tabs {
  ALL = 'all',
  MISSED = 'missed',
}

export const callTypeText: { [key: string]: string } = {
  [CallRecordType.INCOMING]: $localize`Incoming`,
  [CallRecordType.OUTGOING]: $localize`Outgoing`,
  [CallRecordType.MISSED]: $localize`Missed`,
  [CallRecordType.FAILED]: $localize`Failed`,
  [CallRecordType.CANCELLED]: $localize`Cancelled`,
  [CallRecordType.DECLINED]: $localize`Declined`,
};

export const dateGroupText: { [key in DateGroup]: string } = {
  [DateGroup.TODAY]: $localize`Today`,
  [DateGroup.YESTERDAY]: $localize`Yesterday`,
  [DateGroup.OLDER]: $localize`Older`,
};
